/* ============================================================
   NL Invisible Lift — MAIN-PRODUCT script (separate file)
   NEW elements/behaviors layered on top of the theme's main-product:
   - ATC button guarantee subtext
   - viewers counter (scarcity card)
   - refill line that follows the selected Buy More tile
   - "Buy once" → selects the first tile
   - sticky ATC bar (appears after scrolling past the ATC button)
   No theme file is touched; loaded via the "Custom liquid"
   block (NL assets) — remove that block to switch it all off.
   ============================================================ */
(function () {
  'use strict';

  // fallback refill lines; the real source is the "Refill line per tile quantity"
  // setting of the NL Checklist block (data-refill-map attribute, "qty|text" per line)
  var REFILL_BY_QTY = {
    1: '1 Invisible Lift pair at $55/ea every 3 months',
    2: '2 Invisible Lift pairs at $34.50/ea every 3 months',
    4: '4 Invisible Lift pairs at $34.50/ea every 6 months',
    5: '5 Invisible Lift pairs at $41.40/ea every 6 months'
  };
  function refillMap() {
    var el = document.querySelector('[data-refill-map]');
    if (!el) return REFILL_BY_QTY;
    var map = {};
    String(el.getAttribute('data-refill-map')).split('\n').forEach(function (line) {
      var p = line.indexOf('|');
      if (p > 0) map[line.slice(0, p).trim()] = line.slice(p + 1).trim();
    });
    return Object.keys(map).length ? map : REFILL_BY_QTY;
  }
  var SHIELD = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l8 3v6c0 5-3.4 8-8 9-4.6-1-8-4-8-9V6l8-3z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M9 12l2 2 4-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function mainAtcButton() {
    var buyMore = document.querySelector('.omr-buy-more');
    var scope = buyMore ? buyMore.closest('form') : null;
    if (scope) {
      var b = scope.querySelector('button[name="add"]');
      if (b) return b;
    }
    return document.querySelector('.hdt-product-form__submit');
  }

  /* ------------------------------------------------------------------
     Quote slider — one nested "Quote slide" block per view, dot
     pagination, optional idle-based auto-advance. Re-runnable: each
     slider is tagged once so a theme-editor re-render can call this
     again without double-binding.
     ------------------------------------------------------------------ */
  function initQuoteSliders() {
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    document.querySelectorAll('[data-nl-quote]').forEach(function (root) {
      if (root.hasAttribute('data-nl-quote-ready')) return;
      var track = root.querySelector('[data-nl-quote-track]');
      if (!track) return;
      root.setAttribute('data-nl-quote-ready', '');
      var dotsWrap = root.querySelector('[data-nl-quote-dots]');

      function slides() { return track.querySelectorAll('.nl-mp-quote__slide'); }
      function count() { return slides().length; }
      function stepW() { return track.clientWidth || 1; }
      function current() { return Math.round(track.scrollLeft / stepW()); }

      // keep the aria label the merchant typed in the block settings
      var firstDot = dotsWrap ? dotsWrap.querySelector('.nl-mp-quote__dot') : null;
      var dotLabel = firstDot ? String(firstDot.getAttribute('aria-label') || '').replace(/\s*\d+\s*$/, '') : '';
      if (!dotLabel) dotLabel = 'Go to quote';

      var dots = [];
      var activeIdx = 0;

      function syncDots() {
        activeIdx = current();
        for (var d = 0; d < dots.length; d++) {
          var on = d === activeIdx;
          dots[d].classList.toggle('on', on);
          if (on) dots[d].setAttribute('aria-current', 'true');
          else dots[d].removeAttribute('aria-current');
        }
      }

      // Liquid renders the dots, but a hidden/removed slide would leave a
      // stray one behind — rebuild from the slides actually in the DOM.
      function buildDots() {
        if (!dotsWrap) return;
        var n = count();
        dots = [];
        dotsWrap.innerHTML = '';
        if (n < 2) { dotsWrap.hidden = true; return; }
        dotsWrap.hidden = false;
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'nl-mp-quote__dot';
          b.setAttribute('data-nl-quote-dot', i);
          b.setAttribute('aria-label', dotLabel + ' ' + (i + 1));
          dotsWrap.appendChild(b);
          dots.push(b);
        }
        syncDots();
      }
      buildDots();

      var programmatic = false;
      var lastInteraction = Date.now();
      var hovering = false;
      var inView = true;
      function mark() { lastInteraction = Date.now(); }

      function goTo(i, instant) {
        var n = count();
        if (n < 2) return;
        i = ((i % n) + n) % n;
        var target = i * stepW();
        programmatic = true;
        track.scrollTo({ left: target, behavior: instant ? 'instant' : 'smooth' });
        setTimeout(function () {
          // fallback when the smooth animation is frozen (hidden/background tab)
          if (Math.abs(track.scrollLeft - target) > 4) track.scrollTo({ left: target, behavior: 'instant' });
          programmatic = false;
          syncDots();
        }, 600);
      }

      if (dotsWrap) {
        dotsWrap.addEventListener('click', function (e) {
          var b = e.target.closest ? e.target.closest('[data-nl-quote-dot]') : null;
          if (!b) return;
          mark();
          goTo(parseInt(b.getAttribute('data-nl-quote-dot'), 10) || 0);
        });
      }

      // throttled with a timer rather than rAF so the dots still follow a
      // swipe when the tab is backgrounded (rAF is paused there)
      var sync = 0;
      track.addEventListener('scroll', function () {
        if (!programmatic) mark();
        if (sync) return;
        sync = setTimeout(function () { sync = 0; syncDots(); }, 60);
      }, { passive: true });

      track.addEventListener('mouseenter', function () { hovering = true; mark(); });
      track.addEventListener('mouseleave', function () { hovering = false; mark(); });
      track.addEventListener('wheel', mark, { passive: true });
      track.addEventListener('pointerdown', mark, { passive: true });
      track.addEventListener('touchstart', mark, { passive: true });

      // a width change moves every snap point — re-anchor on the same slide
      var rt = 0;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () { goTo(activeIdx, true); }, 150);
      });

      // theme editor: bring the slide being edited into view
      if (designMode) {
        document.addEventListener('shopify:block:select', function (e) {
          var slide = e.target && e.target.closest ? e.target.closest('.nl-mp-quote__slide') : null;
          if (!slide || !track.contains(slide)) return;
          var idx = Array.prototype.indexOf.call(slides(), slide);
          if (idx > -1) goTo(idx);
        });
        return; // no auto-advance while editing
      }

      var secs = parseInt(root.getAttribute('data-nl-quote-autoplay'), 10);
      if (!(secs > 0)) return;
      if ('IntersectionObserver' in window) {
        inView = false;
        new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; }, { threshold: 0.4 }).observe(root);
      }
      setInterval(function () {
        if (hovering || !inView || document.hidden) return;
        if (Date.now() - lastInteraction < secs * 1000) return;
        var n = count();
        if (n < 2) return;
        var next = activeIdx + 1;
        // wrapping back to the first slide jumps instead of sweeping through all of them
        goTo(next, next >= n);
        lastInteraction = Date.now();
      }, 500);
    });
  }

  function init() {
    if (!document.querySelector('.omr-buy-more') && !document.querySelector('.nl-mp-headline')) return;
    document.documentElement.classList.add('nl-mp');

    // ATC guarantee subtext (injected inside the theme button; text comes from the NL Checklist block setting)
    var atc = mainAtcButton();
    if (atc && !atc.querySelector('.nl-mp-atc-sub')) {
      var subSrc = document.querySelector('[data-nl-atc-sub-text]');
      var subText = subSrc ? subSrc.textContent.trim() : '30 Day Money-Back Guarantee';
      if (subText) {
        var sub = document.createElement('span');
        sub.className = 'nl-mp-atc-sub';
        sub.innerHTML = SHIELD;
        sub.appendChild(document.createTextNode(subText));
        atc.appendChild(sub);
      }
    }

    // viewers counter
    setInterval(function () {
      var el = document.querySelector('[data-nl-viewers]');
      if (el) el.textContent = Math.max(6, 10 + Math.floor(Math.random() * 9) - 3);
    }, 5200);

    // "Order within [clock] ... [day]" in the Feel the Difference section
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var dd = new Date(); dd.setDate(dd.getDate() + 4);
    document.querySelectorAll('[data-nl="day"]').forEach(function (el) { el.textContent = days[dd.getDay()]; });
    var cd = 900;
    setInterval(function () {
      cd = cd > 0 ? cd - 1 : 900;
      var m = Math.floor(cd / 60), s = cd % 60;
      var txt = m + ':' + (s < 10 ? '0' : '') + s;
      document.querySelectorAll('[data-nl="clock"]').forEach(function (el) { el.textContent = txt; });
    }, 1000);

    // refill line follows the active Buy More tile
    function syncRefill() {
      var active = document.querySelector('.omr-buy-more__row.active');
      var refill = document.querySelector('[data-nl-refill]');
      if (!active || !refill) return;
      var txt = refillMap()[active.getAttribute('data-qty')];
      if (txt) refill.textContent = txt;
    }
    // design price row follows the active tile (price + was + SAVE%)
    function syncPrice() {
      var priceEl = document.querySelector('[data-nl-price]');
      var active = document.querySelector('.omr-buy-more__row.active');
      if (!priceEl || !active) return;
      var now = active.querySelector('.omr-buy-more__price');
      var was = active.querySelector('.omr-buy-more__price-original');
      var wasEl = document.querySelector('[data-nl-was]');
      var saveWrap = document.querySelector('[data-nl-save-wrap]');
      var saveEl = document.querySelector('[data-nl-save]');
      if (now) priceEl.textContent = now.textContent.trim();
      var n = now ? parseFloat(now.textContent.replace(/[^0-9.]/g, '')) : 0;
      var w = was ? parseFloat(was.textContent.replace(/[^0-9.]/g, '')) : 0;
      if (wasEl) {
        if (was && w > n) { wasEl.textContent = was.textContent.trim(); wasEl.style.display = ''; }
        else { wasEl.style.display = 'none'; }
      }
      if (saveWrap && saveEl) {
        if (w > n && n > 0) { saveEl.textContent = Math.round((1 - n / w) * 100); saveWrap.style.display = ''; }
        else { saveWrap.style.display = 'none'; }
      }
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.omr-buy-more__row')) setTimeout(function () { syncRefill(); syncPrice(); }, 50);
    });
    syncRefill();
    syncPrice();

    // Recognition slider: seamless infinite loop + 5s autoplay.
    // The first 4 cards are cloned to the end of the track; when the scroll
    // enters the cloned region the position is silently reset by one loop
    // width, so the loop never visibly sweeps back to the start.
    (function () {
      var track = document.querySelector('.nl-il-desk .nl-recog-track');
      if (!track) return;
      var originals = track.querySelectorAll('article').length;
      if (originals < 5) return; // 4 or fewer cards: static row, no slider
      var designMode = window.Shopify && window.Shopify.designMode;
      if (!designMode) {
        var arts = track.querySelectorAll('article');
        for (var ci = 0; ci < Math.min(4, arts.length); ci++) {
          var cl = arts[ci].cloneNode(true);
          cl.setAttribute('aria-hidden', 'true');
          track.appendChild(cl);
        }
      }
      function stepW() {
        var card = track.querySelector('article');
        return card ? card.getBoundingClientRect().width + 16 : track.clientWidth / 4;
      }
      function loopW() { return stepW() * originals; }
      function normalize() {
        if (designMode) return;
        var lw = loopW();
        if (track.scrollLeft >= lw - 2) track.scrollTo({ left: track.scrollLeft - lw, behavior: 'instant' });
      }
      var programmatic = false;
      function go(dir) {
        var s = stepW();
        if (designMode) {
          // no clones in the theme editor: plain wrap-around instead
          var max = track.scrollWidth - track.clientWidth;
          var t;
          if (dir === 1 && track.scrollLeft >= max - 4) t = 0;
          else if (dir === -1 && track.scrollLeft <= 4) t = max;
          else t = Math.max(0, Math.min(max, track.scrollLeft + dir * s));
          track.scrollTo({ left: t, behavior: 'smooth' });
          return;
        }
        programmatic = true;
        normalize();
        if (dir === -1 && track.scrollLeft <= 2) track.scrollTo({ left: track.scrollLeft + loopW(), behavior: 'instant' });
        var target = track.scrollLeft + dir * s;
        track.scrollTo({ left: target, behavior: 'smooth' });
        // fallback if the smooth animation is frozen (hidden/background tab),
        // then silently re-enter the original region when inside the clones
        setTimeout(function () {
          if (Math.abs(track.scrollLeft - target) > 4) track.scrollTo({ left: target, behavior: 'instant' });
          normalize();
          programmatic = false;
        }, 700);
      }

      // Autoplay is idle-based: ANY interaction (arrow click, hover, manual
      // scroll/swipe/wheel, pressing a card) resets the countdown, and the
      // slider only auto-advances once 5s have passed with no interaction.
      var hovering = false;
      var inView = true;
      var lastInteraction = Date.now();
      function markInteraction() { lastInteraction = Date.now(); }

      // arrows
      document.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-nl-recog]') : null;
        if (!btn) return;
        go(btn.getAttribute('data-nl-recog') === 'next' ? 1 : -1);
        markInteraction();
      });
      track.addEventListener('mouseenter', function () { hovering = true; markInteraction(); });
      track.addEventListener('mouseleave', function () { hovering = false; markInteraction(); });
      track.addEventListener('wheel', markInteraction, { passive: true });
      track.addEventListener('pointerdown', markInteraction, { passive: true });
      track.addEventListener('touchstart', markInteraction, { passive: true });
      // manual scrolls only — the script's own scrolls are flagged programmatic
      track.addEventListener('scroll', function () { if (!programmatic) markInteraction(); }, { passive: true });

      if ('IntersectionObserver' in window) {
        inView = false;
        new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; }, { threshold: 0.3 }).observe(track);
      }
      setInterval(function () {
        if (hovering || !inView || document.hidden || designMode) return;
        if (Date.now() - lastInteraction < 5000) return;
        go(1);
        lastInteraction = Date.now();
      }, 500);
    })();

    initQuoteSliders();

    // "Read More FAQs" → scrolls to the visible FAQ section (desktop or mobile DOM)
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-nl-readmore]') : null;
      if (!t) return;
      e.preventDefault();
      var el = document.getElementById('nl-faq');
      if (!el || el.offsetParent === null) el = document.getElementById('nl-m-faq');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // "Buy once - no savings" → select the first tile, then show the ATC
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-nl-buyonce]') : null;
      if (!t) return;
      var first = document.querySelector('.omr-buy-more__row');
      if (first) first.click();
      var b = mainAtcButton();
      if (b) b.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    // sticky ATC bar
    var sticky = document.querySelector('[data-nl-sticky]');
    if (sticky) {
      var stickyBtn = sticky.querySelector('[data-nl-sticky-atc]');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          var b = mainAtcButton();
          if (b) b.click();
        });
      }
      var syncSticky = function () {
        var b = mainAtcButton();
        if (!b) return;
        sticky.classList.toggle('is-on', b.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener('scroll', syncSticky, { passive: true });
      window.addEventListener('resize', syncSticky);
      syncSticky();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // adding or removing a quote slide in the theme editor re-renders the
  // section, so the new markup needs wiring up again
  document.addEventListener('shopify:section:load', initQuoteSliders);
})();
